import { Button as AntButton, Checkbox as AntCheckbox } from 'antd';
import { ButtonProps } from 'antd/lib/button/button';
import { CheckboxProps } from 'antd/lib/checkbox/Checkbox';
import styled from 'styled-components';

interface ICheckboxProps extends CheckboxProps {
  borderColor?: string;
  backgroundColor?: string;
  color?: string;
}

interface IButton extends ButtonProps {
  color?: string;
  bordercolor?: string;
  style?: { [key: string]: string | number };
}

const defaultBorderColor = '#494949';

const modifyAntCheckboxBorderColor = ({ borderColor = defaultBorderColor }) => {
  return borderColor;
};

const modifyAntCheckboxColor = ({ color = '#4a4a4a' }) => {
  return color;
};

const modifyAntCheckboxBackgroundColor = ({ backgroundColor = '#fff' }) => {
  return backgroundColor;
};

export const Checkbox = styled(AntCheckbox)<ICheckboxProps>`
  & {
    color: ${modifyAntCheckboxColor};

    &:hover .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    .emp-ant-checkbox-input:focus + .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    &:hover .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }
  }

  .emp-ant-checkbox-checked {
    &::after {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    .emp-ant-checkbox-inner {
      background-color: ${modifyAntCheckboxBackgroundColor};
      border-color: ${modifyAntCheckboxBorderColor};

      &::after {
        border-color: ${modifyAntCheckboxBorderColor};
      }
    }
  }
}
`;

export const Button = styled(AntButton)<IButton>`
   {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    color: ${({ color }) => (color ? color : '#494949')} !important;
    border: ${({ bordercolor }) =>
      bordercolor ? `1px solid ${bordercolor}` : '1px solid #686868'} !important;
    border-radius: 6px;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;

    ${({ style }) => style}
    &:hover {
      border-color: ${({ bordercolor }) => (bordercolor ? bordercolor : '#686868')};
    }
  }
`;
